import { createContext } from 'react';

export const StatusContext = createContext({ status: null, redirectURL: null });
